import { createCmgSimulatorPerson } from '../calculators/cmg_simulator_person';

window.CmgSimulatorPerson = undefined;
document.addEventListener('turbo:load', function() {
  const personCmgSimulatorElement = document.getElementById('paje-simulator-person');

  if (personCmgSimulatorElement) {
    window.CmgSimulatorPerson = createCmgSimulatorPerson();
  }
});
